export const getItemExists = ({ existingItems, itemId, itemType }) => {
  return existingItems ? existingItems.find((item) => item.type === itemType && item.id === itemId) : false
}

export const includesSearchQuery = (string, query) =>
  string ? string.toLowerCase().includes(query.toLowerCase()) : 'untitled'.includes(query.toLowerCase())
